module["exports"] = [
  "#{street_prefix} #{street_suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/street_name.js
// module id = 1182
// module chunks = 0